// material-ui
import { Grid, Stack, Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

// project import
import AuthWrapper from './authentication/AuthWrapper';
import ChangePasswordForm from './ChangePasswordForm';
import { useContext, useEffect } from 'react';
import { AuthContext } from 'auth/auth-context';

// ================================|| CHANGE PASSWORD ||================================ //

const ChangePasswordPage = () => {
  const { organizationName } = useParams()
  const { isSignedIn, loading } = useContext(AuthContext);
  const navigate = useNavigate();


  useEffect(() => {
    if (!isSignedIn && !loading) {
      navigate(`/${organizationName}/login`);
      // console.log('not signed in');
    }
  }, [isSignedIn, loading]);
  
  return (
    <AuthWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
            <Typography variant="h3">Change Password</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <ChangePasswordForm/>
        </Grid>
      </Grid>
    </AuthWrapper>
  );
};

export default ChangePasswordPage;
